<template>
  <v-layout :id="id" style="height: 94%" />
</template>

<script>
import OpenSeadragon from 'openseadragon'
import { Overlay } from './../../helpers/PaperjsOverlay'
import { Path, Point, Raster } from 'paper/dist/paper-core'
const paper = require('paper')

export default {
  name: 'OpenSeaDragonViewer',
  props: {
    id: {
      type: String,
      default: 'openseadragon-viewer'
    },
    shouldShowPois: {
      type: Boolean
    },
    options: {
      type: Object
    },
    i18n: {
      type: Object
    },
    currentPage: {
      type: Number,
      default: 0
    },
    messages: {
      type: Object,
      default: () => ({
        'Tooltips.FullPage': '',
        'Tooltips.Home': '',
        'Tooltips.ZoomIn': '',
        'Tooltips.ZoomOut': '',
        'Tooltips.NextPage': '',
        'Tooltips.PreviousPage': '',
        'Tooltips.RotateLeft': '',
        'Tooltips.RotateRight': '',
        'Errors.Dzc': '',
        'Errors.Dzi': '',
        'Errors.Xml': '',
        'Errors.ImageFormat': '',
        'Errors.Security': '',
        'Errors.Status': '',
        'Errors.OpenFailed': ''
      })
    },
    tileSources: {
      type: Array
    },
    polygonsData: {
      type: Array
    },
    affectAllPolygons: {
      type: Boolean,
      default: false
    },
    translation: {
      type: Object,
      default: () => ({ x: 0, y: 0 })
    },
    scaleValue: {
      type: Number,
      default: 1
    }
  },
  data: function() {
    return {
      viewer: null,
      debugMessage: '',
      componentKey: 0,
      overlay: null,
      path: null,
      tool: null,
      scope: null,
      segment: null,
      movePath: false,
      lastSelected: null,
      dragging: false,
      values: {
        paths: 1,
        minPoints: 4,
        maxPoints: 4,
        minRadius: 400,
        maxRadius: 400
      },
      hitOptions: {
        segments: true,
        stroke: true,
        fill: true,
        tolerance: 5
      },
      drawMarkers: false,
      ourPaper: null,
      lastClickPosition: null,
      currentlyAddedPoi: null,
      previouslyAddedPois: [],
      previouslyAddedPoiRasters: [],
      originalPolygonsData: [] // To store the initial coordinates and sizes of all polygons
    }
  },
  watch: {
    polygonsData: function() {
      this.importFromJSON(this.polygonsData)
    },
    currentPage: function(newVal, oldValue) {
      if (this.viewer !== null) {
        this.viewer.goToPage(newVal)
      }
    },
    tileSources: function(newVal, oldValue) {
      if (this.viewer !== null) {
        this.viewer.open(newVal)
      }
    },
    // Watch for changes in translation or scaleValue and update accordingly
    translation: {
      handler() {
        if (this.affectAllPolygons) {
          this.moveAllPaths() // Update movement on translation change
        }
      },
      deep: true
    },
    scaleValue(newValue) {
      this.scaleAllPaths() // Update scaling on scaleValue change
    }
  },
  created() {},
  mounted() {
    this.setup()
    // this.insertMarkersForPois()
    paper.settings.handleSize = 16
  },
  updated() {
    this.setup()
    // this.insertMarkersForPois()
  },
  beforeDestroy: function() {
    this.viewer.destroy()
    this.viewer = null
  },
  methods: {
    insertMarkersForPois: function() {
      let pois = this.$store.state.MediaStore.linkedPois[0]
      if (Array.isArray(pois)) {
        var src = require('../../assets/map-marker-filled.png')
        pois.forEach(e => {
          let point = new Point(e.poiCoordinates[0], e.poiCoordinates[1])
          let raster = new paper.Raster({
            source: src,
            position: point,
            data: { name: e.name, type: e.type }
          })
          var text = new paper.PointText({
            point: [e.poiCoordinates[0], e.poiCoordinates[1] + 280],
            justification: 'center',
            fillColor: 'black',
            content: e.name,
            fontWeight: 'bold',
            fontSize: 140,
            strokeColor: new paper.Color(1, 1, 1),
            strokeWidth: 5
          })

          this.previouslyAddedPoiRasters.push(raster)
          this.previouslyAddedPois.push(e)
          setTimeout(() => {
            raster.scale(
              (3.5 * this.calculateResizeFactor()) /
                this.viewer.viewport.getZoom()
            )
          }, 100)
        })
      } else {
        return
      }
    },
    removeImagesFromProject() {
      var items = paper.project.activeLayer.getItems()
      items = items.filter(e => e.data.type === 'poi')
      items.map(e => e.remove())
      let result = this.exportToJSON()
      return result
    },
    setup: function() {
      if (!this.viewer) {
        var self = this
        const _options = Object.assign({}, this.options)
        _options.id = this.id
        this.viewer = OpenSeadragon(_options)

        //This is a ipad performance fix
        // this.viewer.addHandler("canvas-release", function(viewer) {
        //   document.getElementById("favorites").focus();
        // });
        // this.viewer.addHandler("canvas-pinch", function(viewer) {
        //   document.getElementById("favorites").focus();
        // });
        // this.viewer.addHandler("animation-finish", function(viewer) {
        //   document.getElementById("favorites").focus();
        // });
      }

      this.viewer.open(this.tileSources)
      this.viewer.gestureSettingsMouse.clickToZoom = false
      this.paperOverlayInit(this.viewer)

      // event listeners

      // this.overlay
      // 	.paperCanvas()
      // 	.addEventListener("mousedown", self.onMouseDown);
      // this.overlay.paperCanvas().addEventListener("mouseup", self.onMouseUp);
      // this.overlay
      // 	.paperCanvas()
      // 	.addEventListener("mousemove", self.onMouseMove);
      // this.overlay.paperCanvas().addEventListener("keypress", self.onKeyUp);

      new OpenSeadragon.MouseTracker({
        element: self.viewer.canvas,
        pressHandler: self.onMouseDown,
        dragHandler: self.doDrag,
        dragEndHandler: self.dragEndHandler,
        keyUpHandler: self.onKeyUp,
        releaseHandler: self.dragEndHandler
      }).setTracking(true)

      this.importFromJSON(this.polygonsData)
      if (this.shouldShowPois) {
        this.insertMarkersForPois()
      }
      this.viewer.addHandler('zoom', function(viewer, contentSize) {
        let currentZoom = self.viewer.viewport.getZoom()

        if (
          currentZoom + 0.1 < self.viewer.maxZoomLevel &&
          currentZoom - 0.1 > self.viewer.minZoomLevel
        ) {
          var src = require('../../assets/map-marker-filled.png')

          if (self.lastClickPosition !== null) {
            if (self.currentlyAddedPoi !== null) self.currentlyAddedPoi.remove()
            let point = new Point(
              self.lastClickPosition.x,
              self.lastClickPosition.y
            )

            self.currentlyAddedPoi = new paper.Raster({
              source: src,
              position: point,
              data: { name: 'currentPin', type: 'poiType' }
            })
          }
          if (self.currentlyAddedPoi != null) {
            self.currentlyAddedPoi.scale(
              (3.5 * self.calculateResizeFactor()) / currentZoom
            )
          }
          if (Array.isArray(self.previouslyAddedPoiRasters)) {
            console.log(self.previouslyAddedPoiRasters)
            self.previouslyAddedPoiRasters.forEach(raster => {
              raster.clear()
            })
            self.previouslyAddedPoiRasters = []
          }

          if (Array.isArray(self.previouslyAddedPois)) {
            self.previouslyAddedPois.forEach(poi => {
              let point = new Point(
                poi.poiCoordinates[0],
                poi.poiCoordinates[1]
              )
              var raster = new paper.Raster({
                source: src,
                position: point,
                data: { name: poi.name, type: poi.type }
              })
              raster.scale((3.5 * self.calculateResizeFactor()) / currentZoom)
              self.previouslyAddedPoiRasters.push(raster)
            })
          }
        }
      })
      this.storeInitialPolygonsData()
      //window.addEventListener("keypress", self.onKeyUp);
    },
    paperOverlayInit(viewer) {
      var self = this
      //paper = new paper.PaperScope();
      this.overlay = new Overlay(viewer)

      // paper.setup(this.overlay.paperCanvas());
      // this.tool = this.createTool(self.scope);

      OpenSeadragon.Viewer.prototype.paperjsOverlay = this.overlay

      console.log('OVERLAYING paper')
      // this._paperjsOverlayInfo = new Overlay(this);
      // return this._paperjsOverlayInfo;

      this.overlay.resize()
      this.overlay.resizecanvas()

      // paper = new paper.PaperScope();
      // paper.setup(this.overlay.paperCanvas());
      // this.tool = this.createTool(self.scope);
      //console.log("SCOPE: ", paper);
      //paper.view.draw();

      // new OpenSeadragon.MouseTracker({
      //   element: self.viewer.canvas,
      //   pressHandler: self.press_handler,
      //   dragHandler: self.drag_handler,
      //   dragEndHandler: self.dragEnd_handler
      // }).setTracking(true);

      //this.overlay.paperCanvas().add(circle);
      //paper.project.activeLayer.addChild(circle);
    },
    onMouseDown(event) {
      // in order to access functions in nested tool

      let self = this

      // create drawing tool
      //this.tool = this.createTool(paper);
      // this.tool.onMouseDown = (event) => {
      // 	// init path
      // 	self.path = self.pathCreate(self.scope);
      // 	// add point to path
      // 	self.path.add(event.point);
      // };
      // this.tool.onMouseDrag = (event) => {
      // 	self.path.add(event);
      // };
      // this.tool.onMouseUp = (event) => {
      // 	// line completed
      // 	self.path.add(event.point);
      // };
      let markerResizeFactor = this.calculateResizeFactor()

      if (this.shouldShowPois) {
        this.lastClickPosition = paper.view.viewToProject(
          new paper.Point(event.position.x, event.position.y)
        )
        var src = require('../../assets/map-marker-filled.png')

        if (this.lastClickPosition !== null) {
          if (this.currentlyAddedPoi !== null) this.currentlyAddedPoi.remove()
          let point = new Point(
            this.lastClickPosition.x,
            this.lastClickPosition.y
          )

          this.currentlyAddedPoi = new paper.Raster({
            source: src,
            position: point,
            data: { name: 'currentPin', type: 'poiType' }
          })
          this.currentlyAddedPoi.scale(
            (3.5 * this.calculateResizeFactor()) /
              this.viewer.viewport.getZoom()
          )
          this.currentlyAddedPoi.handles.remove() // this will throw Uncaught errors but it works.
        }

        // if we zoom in / zoom out the pin gets redrawn in the addHandler ( 'zoom' ) function
      }

      self.segment = self.path = null
      var transformed_point = paper.view.viewToProject(
        new paper.Point(event.position.x, event.position.y)
      )
      self.$emit('point', transformed_point)
      var hitResult = paper.project.hitTest(transformed_point, self.hitOptions)
      //       hit_item = null;
      // var transformed_point = paper.view.viewToProject(new paper.Point(event.position.x, event.position.y));
      // var hit_test_result = paper.project.hitTest(transformed_point);
      // if (hit_test_result) {
      // 	hit_item = hit_test_result.item;
      // }

      // remove selection
      if (self.lastSelected && self.lastSelected !== event.item) {
        self.lastSelected.selected = false
        self.onDeselect()
      }
      if (!hitResult) {
        this.onDeselect()
        return
      }
      if (event.originalEvent.shiftKey) {
        if (hitResult.type == 'segment') {
          hitResult.segment.remove()
        }
      }

      if (hitResult.type === 'pixel') {
        hitResult.item.selected = true
        if (self.lastSelected) {
          self.lastSelected.selected = false
        }
        self.lastSelected = hitResult.item
        self.onSelect(hitResult.item)
      } else {
        this.viewer.setMouseNavEnabled(false)
        const notLinkedAssets = this.$store.state.MediaStore.notLinkedAssets
        const asset = notLinkedAssets.filter(
          ele => ele.id === hitResult.item.data.linkedRecord.id
        )

        hitResult.item.selected = true
        if (asset.length) {
          hitResult.item.data.name = asset[0].name
        }
        self.lastSelected = hitResult.item
        self.onSelect(self.lastSelected)
        self.path = hitResult.item
        if (hitResult.type == 'segment') {
          if (event.originalEvent.shiftKey) {
            hitResult.segment.remove()
            return
          }
          self.segment = hitResult.segment
        } else if (hitResult.type == 'stroke') {
          var location = hitResult.location
          self.segment = self.path.insert(location.index + 1, transformed_point)
          //self.path.smooth();
        }
      }
      if (hitResult.type == 'fill') {
        self.movePath = true
      } else {
        self.movePath = false
      }
      if (self.movePath) paper.project.activeLayer.addChild(hitResult.item)
    },
    doDrag(event) {
      let self = this
      var transformed_point1 = paper.view.viewToProject(new paper.Point(0, 0))
      var transformed_point2 = paper.view.viewToProject(
        new paper.Point(event.delta.x, event.delta.y)
      )
      if (self.segment) {
        //self.segment.point += event.delta;
        // self.segment.point = new paper.Point(
        // 	self.segment.point.x + event.delta.x,
        // 	self.segment.point.y + event.delta.y
        // );

        self.segment.point = self.segment.point.add(
          transformed_point2.subtract(transformed_point1)
        )
        this.viewer.setMouseNavEnabled(false)

        paper.view.draw()
        //path.smooth();
      } else if (self.path) {
        //self.path.position += event.delta;
        // self.path.position = new paper.Point(
        // 	self.path.position.x + event.delta.x,
        // 	self.path.position.y + event.delta.y

        self.path.position = self.path.position.add(
          transformed_point2.subtract(transformed_point1)
        )
        this.viewer.setMouseNavEnabled(false)

        paper.view.draw()
      }
    },

    onKeyUp(event) {
      let self = this

      // When a key is released, set the content of the text item:
      //text.content = 'The ' + event.key + ' key was released!';
      if (event.originalEvent.key === 'c') {
        self.createPaths()
      }

      if (event.originalEvent.key === 'd') {
        self.lastSelected.selected = false
        self.lastSelected.remove()
        self.lastSelected = null
        this.onDelete()
      }
    },

    createPaths() {
      var radiusDelta = this.values.maxRadius - this.values.minRadius
      var pointsDelta = this.values.maxPoints - this.values.minPoints
      for (var i = 0; i < this.values.paths; i++) {
        var radius = this.values.minRadius + Math.random() * radiusDelta
        var points =
          this.values.minPoints + Math.floor(Math.random() * pointsDelta)

        var x = paper.view.size._width * 0.5
        var y = paper.view.size._height * 0.5

        var center = new paper.Point(x, y)
        //center = paper.Point()(paper.view.size * paper.Point.random());
        this.path = this.createBlob(paper.view.center, radius, points)
        var lightness = (Math.random() - 0.5) * 0.4 + 0.4
        var hue = Math.random() * 360
        this.path.fillColor = {
          hue: 0,
          saturation: 1,
          lightness: 1,
          alpha: 0.5
        }
        // this.path.selectedColor = {
        //   hue: 180,
        //   saturation: 1,
        //   lightness: 0.5,
        //   alpha: 0.5
        // }
        this.path.strokeColor = 'white'
        this.path.strokeWidth = 3
      }
    },

    createBlob(center, maxRadius, points) {
      var rectangle = new paper.Rectangle(center, maxRadius)
      var path = new paper.Path.Rectangle(rectangle)
      path.closed = true
      // for (var i = 0; i < points; i++) {
      //   console.log('POINTS FOR ', i, points)
      //   var delta = new paper.Point({
      //     length: maxRadius,
      //     //angle: (360 / points) * i
      //     angle: 90 + 90 *i
      //   })
      //   path.add(new paper.Point(center.x + delta.x, center.y + delta.y))
      // }
      //path.smooth();
      //path.flatten(4);
      path.data = Object.assign(path.data, { linkedRecord: {} })

      return path
    },

    changeZoom(oldZoom, delta) {
      var factor = 1.05
      if (delta < 0) {
        return oldZoom * factor
      }

      if (delta > 0) {
        return oldZoom / factor
      }
    },

    changeCenter(oldCenter, deltaX, deltaY, factor) {
      var offset = new paper.Point(deltaX, -deltaY)
      offset = offset.multiply(factor)
      oldCenter.add(offset)
    },

    dragEndHandler(event) {
      this.viewer.setMouseNavEnabled(true)
      //this.hitResult = null;
    },
    importFromJSON(data) {
      if (data) {
        paper.project.clear()
        paper.project.activeLayer.selected = false
        paper.project.importJSON(data)
      }
    },
    exportToJSON() {
      paper.project.activeLayer.selected = false
      return paper.project.exportJSON({ asString: false })
    },

    getSelectedPolygon() {
      return this.lastSelected
    },

    onSelect(path) {
      this.$emit('selected', path)
    },

    onDeselect() {
      var children = paper.project.activeLayer.getChildren()
      children.forEach(child => (child._selection = 0))
      this.$emit('deselected')
    },
    onDelete() {
      this.$emit('delete')
    },
    calculateResizeFactor() {
      // TODO Use function instead of copy psting code
      let markerResizeFactor = 1

      if (this.viewer !== undefined || this.viewer.world !== undefined) {
        const imageSize = this.viewer.world.getItemAt(0).getContentSize()
        const currentImageSizePixelCount = imageSize.x * imageSize.y
        const standard4kPixelCount = 3840 * 2160
        const windowPixelCount = window.innerWidth * window.innerHeight
        let scaleBigResolutions = 1
        let scaleSmallResolutions = 1

        if (windowPixelCount >= 1920 * 1080)
          scaleBigResolutions = Math.pow(windowPixelCount / (1920 * 1080), 0.05)
        else if (windowPixelCount <= 1360 * 720)
          scaleSmallResolutions =
            Math.pow((1920 * 1080) / windowPixelCount, 1.25) / 2.2
        markerResizeFactor =
          Math.cbrt(currentImageSizePixelCount / standard4kPixelCount) *
          scaleSmallResolutions *
          scaleBigResolutions
      }

      return markerResizeFactor
    },
    // Store the initial coordinates and size of all polygons
    storeInitialPolygonsData() {
      const paths = paper.project.activeLayer.children.filter(
        child => child instanceof paper.Path
      )

      this.originalPolygonsData = paths.reduce((acc, path) => {
        acc[path.id] = {
          points: path.segments.map(segment => segment.point),
          bounds: path.bounds,
          position: path.position
        }
        return acc
      }, {})
    },

    // Function to scale the polygons by a centroid-based uniform scale
    scaleAllPaths() {
      const scaleFactor = parseFloat(this.scaleValue)

      // If "Affect all polygons" is not checked, use only the last selected polygon
      if (!this.affectAllPolygons && this.path) {
        this.scaleSinglePath(this.path, scaleFactor)
        return
      }
      if (!this.affectAllPolygons && !this.path) return
      // Calculate the centroid of all polygons
      const paths = paper.project.activeLayer.children.filter(
        child => child instanceof paper.Path
      )
      let centroid = new paper.Point(0, 0)
      let totalArea = 0

      paths.forEach(path => {
        centroid = centroid.add(path.bounds.center)
        totalArea++
      })
      centroid = centroid.divide(totalArea) // Average centroid of all polygons

      // Apply uniform scaling around the centroid
      paths.forEach((path, index) => {
        const initialData = this.originalPolygonsData[path.id]

        // Calculate scaling factor based on the initial width of the path
        const scale =
          scaleFactor * (initialData.bounds.width / path.bounds.width)

        // Scale each path from the centroid
        path.scale(scale, centroid)
      })

      paper.view.draw()
    },
    scaleSinglePath(path, scaleFactor) {
      // Find the initial data based on the path's unique ID
      const initialData = this.originalPolygonsData[path.id]

      if (!initialData) {
        console.error('Initial data not found for the path.')
        return
      }

      const centroid = path.bounds.center

      // Calculate the scaling factor as an absolute transformation (not incremental)
      const scale = scaleFactor * (initialData.bounds.width / path.bounds.width)
      // Apply the scaling transformation on the single path
      path.scale(scale, centroid)

      paper.view.draw()
    },

    // Function to move the polygons based on x and y translation
    moveAllPaths() {
      // this parsing should move to the watch but alas
      let x = parseFloat(this.translation.x)
      let y = parseFloat(this.translation.y)

      if (isNaN(x)) x = 0
      if (isNaN(y)) y = 0

      const paths = paper.project.activeLayer.children.filter(
        child => child instanceof paper.Path
      )

      // Move each path based on the initial position + translation
      paths.forEach((path, index) => {
        const initialData = this.originalPolygonsData[path.id]
        const translationVector = new paper.Point(x, y)

        // Move the polygon by the translation values, based on initial position
        path.position = initialData.position.add(translationVector)
      })

      paper.view.draw()
    }

    // resolve: function(object, key) {
    //   try {
    //     const _keys = key.split('.')
    //     let _cursor = object
    //     for (const _key of _keys) {
    //       _cursor = _cursor[_key]
    //     }
    //     return _cursor
    //   } catch (e) {
    //     return null
    //   }
    // },

    /**
     @see https://openseadragon.github.io/examples/ui-customize-tooltips/
     */
    // translate: function() {
    //   if (!this.i18n || !this.messages) {
    //     return
    //   }
    //
    //   const _messages = this.i18n.messages[this.i18n.locale]
    //   for (const label in this.messages) {
    //     OpenSeadragon.setString(
    //       label,
    //       this.resolve(_messages, this.messages[label])
    //     )
    //   }
    // }
  }
}
</script>
